<template>
  <div>
    <ul class="product-group">
      <li v-for="(list, index) in listInfo" :key="index" :class="isSelected('group_'+groupIndex+'_'+index)">
        <span class="product-name">
          <input type="radio" :id="productType+groupIndex+groupName+index" :name="'voucher_'+index" :value="'group_'+groupIndex+'_'+index"
                 :class="isSelected('group_'+groupIndex+'_'+index)" v-model="selectedValue">
          <label :for="productType+groupIndex+groupName+index">
            <span v-if="productType === 'one' || productType === 'package'">
              <span class="product-title">
                {{ list.concurrency[0].product_name }}
                <div class="question-popup-wrap">
                   <button type="button" v-if="isDescription(list.concurrency[0].description)" :class="tooltipToggle ? 'question-btn on' : 'question-btn' " @click.prevent="clickTooltip(tooltipToggle)"></button>
                  <span class="question-popup" v-if="tooltipToggle"> <!--question-popup-->
                    <span class="question-txt">시청 가능 콘텐츠<br />{{list.concurrency[0].description}}</span>
                    <button type="button" class="btn-popup-close" @click="close()">
                      <span class="a11y-hidden">닫기</span>
                    </button>
                  </span>
                </div>
              </span>
              <span class="product-metadata">
                <span class="product-price">{{ setNumberCommas(list.concurrency[0].amount) }}원/{{list.concurrency[0].use_day}}</span>
              </span>
            </span>
            <span v-else>
              <span class="product-title">{{ list.concurrency[0].product_name }}</span>
              <span class="product-metadata">
                <span class="product-description">{{ list.concurrency[0].description }}</span>
                <span class="product-price">{{setNumberCommas(list.concurrency[parseInt(userLine)].amount)}}원</span>
              </span>
            </span>
          </label>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { EventBus } from '@/components/lnb/voucher/VoucherEventBus'
import utils from '@/common/util/utils'
export default {
  name: 'AllProductsNew',
  props: {
    listInfo: {
      type: Array
    },
    userLine: {
      type: String
    },
    productType: {
      type: String
    },
    groupName: {
      type: String
    },
    groupIndex: {
      type: String
    },
    categoryIndex: {
      type: Number
    },
    setNumberCommas: {
      type: Function
    },
    menuName: {
      type: String
    },
    currentIndex: {
      type: String
    }
  },
  data () {
    return {
      userCount: 1,
      device: utils.cookies.getDevice(),
      selectedValue: '',
      tooltipToggle: false
    }
  },
  methods: {
    isSelected (index) {
      if (this.currentIndex === index) {
        return ' checked'
      }
    },
    clickTooltip (toggle) {
      this.tooltipToggle = !toggle
    },
    close () {
      this.tooltipToggle = false
    },
    isDescription (description) {
      return description.trim() !== ''
    },
  },
  watch: {
    selectedValue () {
      let indexInfo = this.selectedValue.split('_')
      if (this.selectedValue === this.currentIndex) return
      EventBus.$emit('popupSelectedVoucher', { list: this.listInfo[indexInfo[3]], selectedIndex: this.selectedValue, productType: this.productType })
    }
  }
}
</script>
